import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';
import { useTenant } from '../../context/TenantContext';

export const useGetGroupDetails = (id) => {
  const client = useApi();
  const { env } = useTenant();

  return useQuery(['group-details', id], () =>
    client.get(`${env.REACT_APP_BACKEND_PORTAL_URL}/users/multi-access/kamGroup/${id}`).then((res) => res.data),
  );
};
